export const getAddresses = async () => {
  try {
    const token = localStorage.getItem("token"); // or pass auth.token if available
    if (!token) throw new Error("No authentication token found");

    const response = await fetch(`${process.env.REACT_APP_SERVER_DOMAIN}/api/address`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error(`Failed to fetch addresses: ${response.status} ${response.statusText}`);
    }

    return await response.json();
  } catch (error) {
    console.error("Error fetching addresses:", error);
    throw error; // let the caller handle UI feedback
  }
};